var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isVisible
      ? _c(
          "div",
          { staticClass: "modal" },
          [
            _c("div", {
              staticClass: "modal__overlay",
              on: { click: _vm.close },
            }),
            _vm.video
              ? _c("icon-button", {
                  staticClass: "modal__close-video",
                  attrs: { label: "Close Modal", icon: "close", size: "30px" },
                  on: { click: _vm.close },
                })
              : _vm._e(),
            _vm.video
              ? _c("div", { staticClass: "modal__content--video" }, [
                  _c(
                    "div",
                    { staticClass: "modal__content--video__container" },
                    [
                      _c("iframe", {
                        attrs: {
                          width: "853",
                          height: "480",
                          src: _vm.videoUrl,
                          frameborder: "0",
                          allowfullscreen: "",
                        },
                      }),
                    ]
                  ),
                ])
              : _c(
                  "div",
                  { staticClass: "modal__content" },
                  [
                    _c("icon-button", {
                      staticClass: "modal__close",
                      attrs: { label: "Close Modal", icon: "close" },
                      on: { click: _vm.close },
                    }),
                    _vm._t("content"),
                  ],
                  2
                ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }